import { render, staticRenderFns } from "./platform.vue?vue&type=template&id=6ccdf893&scoped=true&"
import script from "./platform.vue?vue&type=script&lang=js&"
export * from "./platform.vue?vue&type=script&lang=js&"
import style0 from "./platform.vue?vue&type=style&index=0&id=6ccdf893&lang=less&scoped=true&"
import style1 from "./platform.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccdf893",
  null
  
)

export default component.exports